import React, { useState, useEffect, useCallback } from 'react';
import { ReactComponent as DegustacionesIcon } from '../assets/icons/MiembrosIcon.svg';
import { db } from '../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../assets/LoadingSpinner';
import { useToast } from '../contexts/ToastContext';
const capitalizeFirstLetter = (string) => {
if (!string) return '';
return string.charAt(0).toUpperCase() + string.slice(1);
};
const formatDate = (fechasArray) => {
if (!fechasArray || fechasArray.length === 0) {
return 'Fecha no disponible';
}
const dateString = fechasArray[0];
const date = new Date(dateString);
const fullDateString = date.toLocaleDateString('es-ES', {
weekday: 'long',
year: 'numeric',
month: 'long',
day: 'numeric'
});
const parts = fullDateString.split(',');
if (parts.length > 0) {
const capitalizedDay = capitalizeFirstLetter(parts[0].trim());
return capitalizedDay + ', ' + parts.slice(1).join(',').trim();
}
return fullDateString;
};
const ReservaModal = ({
selectedDegustacion, invitados, cantidadInvitados, isReserving, reservaError, reservaSuccess,
setShowModal, handleInvitadoChange, handleCantidadInvitadosChange, handleReservaSubmit,
userName
}) => {
const inputsVisibles = [];
for (let i = 0; i < cantidadInvitados; i++) {
inputsVisibles.push(i);
}
return (
<div className="modal-backdrop" onClick={() => setShowModal(false)}> 
<div className="modal-content" onClick={e => e.stopPropagation()} style={{maxWidth:'650px'}}> 
<div className="modal-close" onClick={() => setShowModal(false)}>&times;</div>
<h2 style={{margin:'0', fontSize:'16px'}}>Su reserva para el {selectedDegustacion ? formatDate(selectedDegustacion.fechas) : 'Cargando...'} a las {selectedDegustacion.hora}</h2>
<form onSubmit={handleReservaSubmit}>
{}
<div className="count-control">
<label htmlFor="num-invitados">Cantidad de Invitados</label>
<input
id="num-invitados"
type="number"
value={cantidadInvitados}
onChange={handleCantidadInvitadosChange}
min="0"
max="3"
className="number-input" 
/>
</div>
{cantidadInvitados > 0 && (
<div >
<p>Por favor, indíquenos el nombre de sus invitados para poder darles una bienvenida personalizada.
</p>
{inputsVisibles.map(i => (
<div style={{display:'flex',justifyContent:'center', gap:'15px',width:'auto',margin:'0 auto', flexDirection:'row', alignItems:'center' }}>
<label style={{color:'#2d193b', fontSize:'14px',fontWeight:'bold', textTransform:'uppercase'}}>Invitado {i + 1}</label>
<input
key={i}
type="text"
value={invitados[i]}
onChange={(e) => handleInvitadoChange(i, e.target.value)}
className="input-invitado" 
required
/></div>
))}
</div>
)}
<p className="info-message" style={{fontSize:'15px', marginTop:'10px'}}>
(Su nombre, {userName || 'el usuario'}, ya está registrado como el titular de la reserva.)
</p>
{reservaError && <p className="error-message">❌ {reservaError}</p>}
{reservaSuccess && <p className="success-message">✅ Reserva confirmada! Te esperamos.</p>}
<div> 
<button 
type="submit" 
disabled={isReserving || reservaSuccess}
className="btn-reservar-modal" 
>
{isReserving ? 'Reservando...' : 'Confirmar Reserva'}
</button>
</div>
</form>
</div>
</div>
);
};
function Degustaciones() {
    const { user } = useAuth();
    const { showToast } = useToast();
    const [degustaciones, setDegustaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedDegustacion, setSelectedDegustacion] = useState(null);
    const [invitados, setInvitados] = useState(['', '', '']);
    const [cantidadInvitados, setCantidadInvitados] = useState(1);
    const [isReserving, setIsReserving] = useState(false);
    const [reservaError, setReservaError] = useState(null);
    const [reservaSuccess, setReservaSuccess] = useState(false);
    const fetchDegustaciones = useCallback(async () => {
            try {
                setLoading(true);
                const degustacionesCol = collection(db, 'degustaciones');
                const degustacionesSnapshot = await getDocs(degustacionesCol);
                const degustacionesList = degustacionesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setDegustaciones(degustacionesList);
                setError(null);
            } catch (err) {
                console.error("Error al cargar degustaciones:", err);
                setError("No se pudieron cargar las degustaciones. Por favor, inténtalo de nuevo más tarde.");
            } finally {
                setLoading(false);
            }
        }, []);
        useEffect(() => {
            fetchDegustaciones();
        }, [fetchDegustaciones]);
    const handleOpenModal = (degustacion) => {
        if (!user) {
            showToast("Debes iniciar sesión para reservar.", 'error');
            return;
        }
        const reservasUsuario = user?.profileData?.reservas || [];
        const yaReservado = reservasUsuario.some(reserva => reserva.degustacionId === degustacion.id);
        if (yaReservado) {
            return;
        }
        setSelectedDegustacion(degustacion);
        setShowModal(true);
        setReservaError(null);
        setReservaSuccess(false);
        setInvitados(['', '', '']);
        setCantidadInvitados(1);
    };
    const handleInvitadoChange = (index, value) => {
        const newInvitados = [...invitados];
        newInvitados[index] = value;
        setInvitados(newInvitados);
    };
    const handleCantidadInvitadosChange = (e) => {
        const newCount = Math.max(0, Math.min(3, parseInt(e.target.value) || 0));
        setCantidadInvitados(newCount);
        const newInvitados = [...invitados];
        for (let i = newCount; i < 3; i++) {
            newInvitados[i] = '';
        }
        setInvitados(newInvitados);
    };
    const handleReservaSubmit = async (e) => {
            e.preventDefault();
            if (!user || !selectedDegustacion || isReserving) return;
            setIsReserving(true);
            setReservaError(null);
            setReservaSuccess(false);
            const invitadosLimpios = invitados
                .filter(nombre => nombre.trim() !== '')
                .map(nombre => ({ nombre: nombre.trim() }));
            const reservaPayload = {
                degustacionId: selectedDegustacion.id,
                userId: user.uid,
                invitados: invitadosLimpios,
            };
            try {
                const idToken = await user.getIdToken();
                const response = await fetch('https://backend-288175208699.europe-west1.run.app/api/reservar-degustacion', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${idToken}`,
                    },
                    body: JSON.stringify(reservaPayload),
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Error al procesar la reserva en el servidor.");
                }
                setReservaSuccess(true);
                await fetchDegustaciones();
                setTimeout(() => {
                    setShowModal(false);
                }, 2500);
            } catch (err) {
                console.error("Fallo la reserva:", err);
                setReservaError(err.message || "Fallo la reserva. Intenta de nuevo.");
            } finally {
                setIsReserving(false);
            }
        };
    if (loading) {
        return <LoadingSpinner/>;
    }
    if (error) {
        return <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>Error: {error}</div>;
    }
    if (degustaciones.length === 0) {
        return <div style={{ textAlign: 'center', padding: '20px' }}>No hay degustaciones programadas actualmente.</div>;
    }
    const MAX_INVITADOS = 8;
return (
<div className="historia-container"  >
<div className="contenido-scrollable" >
<div className="titulo-principal">
<hr className="linea-horizontal" />
<h1>Reserve su Degustación de Cortesía</h1>
<hr className="linea-horizontal" />
</div>
<p className="contenido-centrado">
Es un verdadero placer invitarle a una degustación sin cargo en nuestra finca, una experiencia diseñada exclusivamente para los miembros de nuestra lista de espera.
<br className='spacer-10px'></br>Entendemos que el vino se disfruta más cuando se comparte, por lo que este beneficio se extiende para usted y hasta tres (3) invitados, todos sin costo alguno. Los grupos de degustación son íntimos, con un máximo de ocho personas, para garantizar una experiencia personal y detallada.
<br className='spacer-10px'></br>A continuación, encontrará las próximas fechas que hemos programado. Le sugerimos reservar con antelación, ya que los cupos son limitados.</p>
<div className="titulo-principal" style={{margin:'30px 0'}}>
<hr style={{borderColor:'#ab9374'}} className="linea-horizontal" />
<h1 style={{color:'#ab9374'}}>PrÓXIMAS FECHAS DISPONIBLES</h1>
<hr style={{borderColor:'#ab9374'}} className="linea-horizontal" />
</div>
<ul className="degustaciones-list">
{degustaciones.map((degustacion) => {
const invitadosCount = Array.isArray(degustacion.invitados) ? degustacion.invitados.length : 0;
const lugaresDisponibles = MAX_INVITADOS - invitadosCount;
let esCompleto = lugaresDisponibles <= 0;
const reservasUsuario = user?.profileData?.reservas || [];
const yaReservado = reservasUsuario.some(reserva => reserva.degustacionId === degustacion.id);
const deshabilitarBoton = esCompleto || !user || yaReservado;
const textoBoton = yaReservado ? 'Reservado' : (esCompleto ? 'Completo' : 'Reservar');
let disponibilidadTexto = esCompleto ? 'Completo' : `Quedan ${lugaresDisponibles} lugares`;
const disponibilidadClass = esCompleto 
        ? 'degustacion-disponibilidad--completo' 
        : 'degustacion-disponibilidad--disponible';
      let botonClasses = 'degustacion-btn-reserva';
      if (deshabilitarBoton) {
        botonClasses += ' degustacion-btn-reserva--disabled';
      }
      if (yaReservado) {
        botonClasses += ' degustacion-btn-reserva--reserved';
      }
return (
<li
key={degustacion.id}
className="degustacion-item"
>
<div className="evento-item-fechas">
<DegustacionesIcon style={{ overflow: 'visible', width: '17px', fill:'#a58d70' }} />
<div className="degustacion-info"> {}
<span>{formatDate(degustacion.fechas)}</span>
<span className="separator">-</span> {}
<span>{degustacion.hora || 'S/H'}</span>
<span style={{fontWeight:'normal'}} className={`degustacion-disponibilidad ${disponibilidadClass}`}> {}
({disponibilidadTexto})
</span>
</div>
</div>
<button
onClick={() => handleOpenModal(degustacion)}
disabled={deshabilitarBoton}
className={botonClasses}
>
{textoBoton}
</button>
</li>
)
})}
</ul>
<div className="precio-container" style={{ paddingTop: '15px'}}>
<h2 style={{textTransform:'none', padding:'0 10px', fontSize:'18px'}}>¿Ninguna de estas fechas se ajusta a su agenda?</h2>
<div className="precio-detalles" style={{width:'100%',margin:'0 auto', padding:'35px 0 30px'}}>
<p style={{fontSize: '17px',textAlign:'start',width:'90%', margin:'0 auto'}}>
Nuestras degustaciones se programan cuidadosamente con poca antelación para asegurar la mejor experiencia posible. Si estas opciones no le son convenientes, por favor contáctenos aquí y haremos lo posible por informarle sobre futuras disponibilidades o encontrar una alternativa.
</p>
</div>
</div>
{showModal && selectedDegustacion && (
<ReservaModal
selectedDegustacion={selectedDegustacion}
invitados={invitados}
cantidadInvitados={cantidadInvitados}
isReserving={isReserving}
reservaError={reservaError}
reservaSuccess={reservaSuccess}
setShowModal={setShowModal}
handleInvitadoChange={handleInvitadoChange}
handleCantidadInvitadosChange={handleCantidadInvitadosChange}
handleReservaSubmit={handleReservaSubmit}
userName={user?.profileData?.nombre}
/>
)}</div>
</div>
);
}
export default Degustaciones;